import React from "react";

const SiteContext = React.createContext({
  site: "",
  setSite: () => {},
});

export default SiteContext;
